// types/errors.ts
export class ApiError extends Error {
  constructor(
    public statusCode: number,
    message: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export const POST_ERRORS = {
  ALREADY_EXISTS: "POST_ALREADY_EXISTS",
  UNKNOWN: "UNKNOWN_ERROR",
} as const;

export type PostErrorType = (typeof POST_ERRORS)[keyof typeof POST_ERRORS];
